import React, { useState, useEffect } from 'react';
import { getMyTalentStats, getMyTalentViews } from '../../../../api';
import styles from './ProfileStats.module.css';

const STAT_DEFS = [
  {
    key: 'totalViewers',
    label: '총 방문자',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><ellipse cx="12" cy="12" rx="9" ry="6" stroke="#2BD1FF" strokeWidth="1.5"/><circle cx="12" cy="12" r="2.5" stroke="#2BD1FF" strokeWidth="1.5"/></svg>,
  },
  {
    key: 'weeklyUniqueViewers',
    label: '이번 주 방문자',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><ellipse cx="12" cy="12" rx="9" ry="6" stroke="#1BD879" strokeWidth="1.5"/><circle cx="12" cy="12" r="2.5" stroke="#1BD879" strokeWidth="1.5"/></svg>,
  },
  {
    key: 'bookmarkCount',
    label: '총 저장',
    icon: <svg width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M16 3H5a1 1 0 00-1 1v13.4l6-3.4 6 3.4V4a1 1 0 00-1-1z" stroke="#F0A61C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  },
  {
    key: 'applicationCount',
    label: '총 지원수',
    icon: <svg width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M16 3H5a1 1 0 00-1 1v13.4l6-3.4 6 3.4V4a1 1 0 00-1-1z" stroke="#FF620D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  },
];

function ProfileStats() {
  const [stats, setStats] = useState(null);
  const [views, setViews] = useState(null);

  useEffect(() => {
    getMyTalentStats().then(setStats).catch(() => {});
    getMyTalentViews().then(setViews).catch(() => {});
  }, []);

  function getValue(key) {
    if (key === 'totalViewers') return views?.totalViewers ?? null;
    if (key === 'weeklyUniqueViewers') return views?.weeklyUniqueViewers ?? null;
    return stats?.[key] ?? null;
  }

  return (
    <div className={styles.container}>
      {STAT_DEFS.map((def) => (
        <div key={def.key} className={styles.statBox}>
          <span className={styles.value}>
            {getValue(def.key) != null ? getValue(def.key).toLocaleString() : '—'}
          </span>
          <div className={styles.labelRow}>
            {def.icon}
            <span className={styles.label}>{def.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProfileStats;
